// extracted by mini-css-extract-plugin
export default {"store-search":"store-search__store-search__LFlpC","suggestionsContainer":"store-search__suggestionsContainer__vEayZ","searchInput":"store-search__searchInput__vKEut"};